import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, COLOR } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import i18n from "../../../i18n";
import CellPopover from "ui/grid/DescriptionCell";
import DotCell from "ui/grid/DotCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";

let t = i18n.t;

export const SalesConfirmationGridColumn = (isAdmin: boolean = false) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<DotCell color={handleStatusDot(props.dataItem.status)} />
				),
			},
		},
		{
			field: "id",
			title: t("NumberShort"),
			width: "80px",
		},
		{
			field: "salesType",
			title: t("Type"),
			width: "100px",
		},
		{
			field: "auctionId",
			title: t("AuctionId"),
			width: "100px",
		},
		//...(isAdmin
		//	? [
		//			{
		//				field: "registrationId",
		//				title: t("RegistrationIdShort"),
		//				width: "90px",
		//			} as GridColumnProps,
		//			{
		//				field: "packageId",
		//				title: t("PackageShort"),
		//				width: "60px",
		//			} as GridColumnProps,
		//		]
		//	: []),
		{
			field: "salesTime",
			title: "Åpningsdato",
			width: "110px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.salesTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "confirmationText",
			title: t("Text"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "120px",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "registrationTime",
			title: t("RegistrationTime"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "netLiveWeightKg",
			title: t("TotalWeight"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "buyerAmount",
			title: t("Value"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
	];
	return gridItems;
};

const handleStatusDot = (status: number) => {
	if (status === 3) return COLOR.StatusGreen;
	if (status === 2) return COLOR.YellowLight;
	return "red";
};

export const salesConfirmationDetailGridItems: GridColumnProps[] = [
	{
		//this will not be render
		field: "lineNumber",
		title: "Linje",
	},
	{
		title: t("Line"),
		width: "120px",
		cells: {
			data: (props) => (
				<td style={{ paddingLeft: "10px" }}>{props.dataItem.lineNumber}</td>
			),
		},
	},
	{
		field: "product",
		title: t("Product"),
	},
	{
		field: "numberOfPieces",
		title: t("Pieces"),
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={""} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "price",
		title: t("Price"),
		width: "120px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kr"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "netLiveWeightKg",
		title: t("Weight"),
		width: "120px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "netLiveWeightKg",
		title: t("Value"),
		width: "120px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		width: "40px",
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
];
